// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-dropdown_default__xgnhw","label":"idt-dropdown_label__jx25q"};